import produce from "immer";
import { constants } from "./actions";
import { commonConstants } from "../common/actions";

const { REQUEST, SUCCESS, FAILURE } = commonConstants;
const {
  GET_SCHEDULE,
  CREATE_SCHEDULE_ITEM,
  CREATE_SHIFT_ASSIGNMENT,
  REMOVE_SCHEDULE_ITEM,
} = constants;

const initState = {
  scheduleTimes: [],
  callTakers: [],
  loading: {},
  success: {},
  error: {},
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case GET_SCHEDULE + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: GET_SCHEDULE };
        draft.success = {};
        draft.error = {};
      });
    case CREATE_SHIFT_ASSIGNMENT + REQUEST:
    case CREATE_SCHEDULE_ITEM + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: CREATE_SCHEDULE_ITEM };
        draft.success = {};
        draft.error = {};
      });
    case REMOVE_SCHEDULE_ITEM + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: REMOVE_SCHEDULE_ITEM };
        draft.success = {};
        draft.error = {};
      });

    case GET_SCHEDULE + SUCCESS:
      return produce(state, (draft) => {
        const { shiftAssignments, scheduleTimes } = action.payload;
        draft.scheduleTimes = shiftAssignments ? shiftAssignments.map((sa) => ({...sa, effectiveDate: sa.effectiveDatetime, expiryDate: sa.expiryDatetime})) : scheduleTimes;
        draft.callTakers = action.payload.callTakers.map((c) => {
          return {
            ...c,
            name: `${c.firstName} ${c.lastName}`,
          };
        });
        draft.loading = {};
        draft.success = action.payload;
        draft.error = {};
      });
    case CREATE_SHIFT_ASSIGNMENT + SUCCESS:
      const { shiftAssignment } = action.payload;
      return produce(state, (draft) => {
        draft.scheduleTimes = [
          ...state.scheduleTimes,
          {
            ...shiftAssignment,
            expiryDate: shiftAssignment.expiryDatetime,
            effectiveDate: shiftAssignment.effectiveDatetime,
          },
        ];
        draft.loading = {};
        draft.success = action.payload;
        draft.error = {};
      });

    case CREATE_SCHEDULE_ITEM + SUCCESS:
    case REMOVE_SCHEDULE_ITEM + SUCCESS:
      return produce(state, (draft) => {
        draft.scheduleTimes = action.payload.scheduleTimes
          ? action.payload.scheduleTimes
          : state.scheduleTimes.filter(
              (s) => s.id !== action.payload.deletedShiftAssignmentId
            );
        draft.loading = {};
        draft.success = action.payload.message;
        draft.error = {};
      });
    case GET_SCHEDULE + FAILURE:
    case CREATE_SHIFT_ASSIGNMENT + FAILURE:
    case CREATE_SCHEDULE_ITEM + FAILURE:
    case REMOVE_SCHEDULE_ITEM + FAILURE:
      return produce(state, (draft) => {
        draft.loading = {};
        draft.success = {};
        draft.error = action.payload;
      });
    default:
      return state;
  }
}
